/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

export class GenericModelUtils {
	static findFieldDefinition(fieldDefs, groupName, key) {
		const fieldDefGroup = fieldDefs?.find((x) => x.key === groupName) ?? null;
		return fieldDefGroup?.value?.find((x) => x.key === key) ?? null;
	}
	
	static getModelPrimaryKeyFieldDef(model) {
		return this.getPrimaryKeyFieldDef(model.fieldDefs);
	}
	
	static getModelPrimaryKeyName(model) {
		const primaryKeyFieldDef = this.getModelPrimaryKeyFieldDef(model);
		return primaryKeyFieldDef?.key ?? null;
	}
	
	static getModelPrimaryKeyValue(model, data) {
		return data[this.getModelPrimaryKeyName(model)] ?? null;
	}
	
	static modelDataHasTempId(model) {
		return model && model._tempId != null;
	}
	
	static getPrimaryKeyFieldDef(fieldDefs) {
		// TODO: cache this to improve performance
		let field = fieldDefs.find((x) => Boolean(x.isPrimaryKey) === true);
		
		if(field) {
			return field;
		} else {
			return null;
		}
	}
	
	static getPrimaryKeyName(fieldDefs) {
		let field = this.getPrimaryKeyFieldDef(fieldDefs);
		
		if(field && field.key) {
			return field.key;
		} else {
			return null;
		}
	}
	
	getPrimaryKeyValue(data) {
		let field = this.getPrimaryKeyFieldDef();
		
		if(field && field.getter) {
			return field.getter(data);
		} else {
			return null;
		}
	}
	
	// static getKey(model, data) {
	// 	return model.getPrimaryKeyValue(data);
	// }
	
	static getOptionsForGroup = (fieldGroup) => {
		return {
			renderer: model.groupRenderers?.[fieldGroup.key] ?? 'StandardModelViewerRenderer'
		}
	}

	// static fieldIsVisible(field) {
	// 	const { EditMode, HasPermission, Data, RootData, CustomData } = this.props;
	//
	// 	// primary key is always hidden
	// 	// if the user could change this they
	// 	// might overwrite other data unintentionally
	// 	if(field.isPrimaryKey) {
	// 		return false;
	// 	}
	//
	// 	// if this field is a child of an association
	// 	// it should be hidden if the association is hidden
	// 	if(field.association && !this.fieldIsVisible(field.association)) {
	// 		return false;
	// 	}
	//
	// 	// hide based on viewerOnly and editorOnly rules
	// 	if((EditMode ? field.viewerOnly : field.editorOnly)) {
	// 		return false;
	// 	}
	//
	// 	// hide nullable associations {
	// 	if(this.isHiddenNullableAssociationField(field)) {
	// 		return false;
	// 	}
	//
	// 	let isHidden = false;
	//
	// 	if(typeof field.isHidden == 'object') {
	// 		const { query, requiresPermission } = field.isHidden;
	// 		const SearchContext = ObjectUtils.Merge(ObjectUtils.Clone(Data), { __RootData: RootData, __CustomData: CustomData });
	//
	// 		if(query) {
	// 			isHidden = isHidden || jmespath.search(SearchContext, query);
	// 		}
	// 		if(requiresPermission) {
	// 			isHidden = isHidden || !HasPermission(requiresPermission);
	// 		}
	// 	} else {
	// 		isHidden = isHidden || field.isHidden;
	// 	}
	//
	// 	return !isHidden;
	// }

	static isHiddenNullableAssociationField(fieldDef, data) {
		const association = fieldDef.association;

		if(association && association.name && !fieldDef.isNullableAssociationFieldToggle) {
			// if data is null and the association is nullable
			// (note: !isOne && ArrayOfChildren relationships
			// are not nullable)
			return data?.[association.name] == null && (
				(
					association.type == 'ParentPointer' &&
					association.isNullable
				) || (
					association.type == "ArrayOfChildren" &&
					association.isOne &&
					association.isNullable
				)
			);
		}
		return false;
	}
}
